import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { MiscService, VisitorMedicalConsultationService } from '@services/index';

declare var swal: any;

@Component({
    selector: 'app-util-visitor-parts-medical-consultation-list',
    templateUrl: './list.component.html',
})
export class UtilVisitorPartsMedicalConsultationListComponent implements OnInit {
    @Input() visitor: any = null;
    @Output() updateEvent = new EventEmitter();

    isLoading = true;
    isLoadingVisitors = false;
    selfVisitor = false;
    filter: any = {
        date_begin: null,
        date_end: null
    };
    limit = 20;
    page = 1;
    visitorMedicalConsultations: any;
    hasData = {
        visitorMedicalConsultations: false
    };

    constructor(private cdref: ChangeDetectorRef,
                private miscService: MiscService,
                private visitorMedicalConsultationService: VisitorMedicalConsultationService) {}

    ngOnInit() {
        this.miscService.can("getVisitorMedicalConsultation");
        this.isLoading = true;
        this.selfVisitor = this.miscService.checkDataLength(this.visitor) ? true : false;
        this.getVisitorsMedicalConsultations();
        this.cdref.detectChanges();
    }

    filterVisitorMedicalConsultations(filter = null) {
        this.filter = filter;
        this.getVisitorsMedicalConsultations(true);
    }

    getVisitorsMedicalConsultations(hasFilter = false) {
        this.isLoading = true;
        let data = this.filter;
        data.visitor_ids = this.selfVisitor ? [this.visitor.id] : (this.filter.visitor_ids && this.filter.visitor_ids.length ? this.filter.visitor_ids : null);
        data.limit = this.limit;
        data.page = !hasFilter ? this.page : 1;     // if user has filtered, then reset page to 1 (number of pages can change due to filters)
        this.visitorMedicalConsultationService.getByVisitors(data).subscribe(data => {
            this.visitorMedicalConsultations = data;
            this.hasData.visitorMedicalConsultations = this.miscService.checkDataLength(this.visitorMedicalConsultations.data);
            this.isLoading = false;
        }, error => {
            this.visitorMedicalConsultations = null;
            this.hasData.visitorMedicalConsultations = false;
            this.miscService.showMsg({ msg: "VISITOR_MEDICAL_CONSULTATIONS_NOT_FOUND_PLEASE_CHECK_FILTERS" });
            this.isLoading = false;
        });
    }
    
    addMedicalConsultation() {
        this.getVisitorsMedicalConsultations();
        this.updateEvent.emit();
    }

    switchPage(page) {
        this.page = page;
        this.getVisitorsMedicalConsultations();
    }

    delete(visitorMedicalConsultation) {
        let self = this;
        let title = this.miscService._t('VISITORS_MEDICAL.DELETE_MEDICAL_CONSULTATION') + " ?";
        swal({
            title: title,
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: this.miscService._t('SHARED.CONFIRM'),
            cancelButtonText: this.miscService._t('SHARED.CANCEL'),
            closeOnConfirm: true,
            closeOnCancel: true,
        }, function(isConfirm) {
            if(isConfirm) {
                self.visitorMedicalConsultationService.delete(visitorMedicalConsultation.id).subscribe(data => {
                    self.getVisitorsMedicalConsultations(true);  // resets page to 1 (in case of there is only 1 visitor medical consultation on the current page)
                    self.miscService.showMsg({ msg: "VISITOR_MEDICAL_CONSULTATION_DELETED", status: "success" });
                    self.updateEvent.emit();
                }, error => {
                    self.miscService.showMsg({ msg: "VISITOR_MEDICAL_CONSULTATION_NOT_DELETED" });
                });
            }
        });
    }
}
